import React from 'react';
import FileUploadField from 'components/FileUploadField';
import OrganizationDropdown from 'components/OrganizationDropdown';
import SubmittingSection from 'components/SubmissionSection';
import { isRequired } from 'forms/validators';
import { Form as FinalForm, FormRenderProps } from 'react-final-form';
import { Form, Grid } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { requestedImportGroupedPeople } from 'services/people/actions';
import ErrorAlert from 'components/ErrorAlert';
import { PERSON_GROUPED_PEOPLE_IMPORT_NAMESPACE } from 'services/people/constants';

interface Props {
    onClose: () => void;
}

export default function ImportPeopleForm(props: Props): React.ReactElement {
    const { onClose } = props;

    const dispatch = useDispatch();

    const onSubmit = (values: { file: File; organizationIds: string[] }) => {
        dispatch(requestedImportGroupedPeople(values));
    };

    const renderForm = (
        formProps: FormRenderProps<{ file: File; organizationIds: string[] }>
    ) => (
        <Form onSubmit={formProps.handleSubmit}>
            <Grid>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <FileUploadField
                            name="file"
                            label="Upload file"
                            accept=".csv"
                            validate={isRequired}
                        />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <OrganizationDropdown
                            name="organizationIds"
                            label="Import to the following organizations"
                            multiple
                            validate={isRequired}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <ErrorAlert namespace={PERSON_GROUPED_PEOPLE_IMPORT_NAMESPACE} />
            <SubmittingSection
                submittingButtonParam={{
                    namespace: PERSON_GROUPED_PEOPLE_IMPORT_NAMESPACE
                }}
                normalCancelButtonParam={{
                    onClose: (): void => onClose()
                }}
            />
        </Form>
    );

    return (
        <FinalForm
            onSubmit={onSubmit}
            render={(formProps) => renderForm(formProps)}
        />
    );
}
